export const SET_BREADCRUMBS = "SET_BREADCRUMBS";
export const ADD_REGISTRATION_DETAILS = "ADD_REGISTRATION_DETAILS";
export const SELECT_REGISTRATION = "SELECT_REGISTRATION";
export const CLEAR_SELECTED_REGISTRATION = "CLEAR_SELECTED_REGISTRATION";
export const APPLICATION_SELECTED = "APPLICATION_SELECTED";
export const CLEAR_SELECTED_APPLICATION = "CLEAR_SELECTED_APPLICATION";
export const CLEAR_SECRET_DETAILS = "CLEAR_SECRET_DETAILS";
export const CLEAR_REGISTRATION_DETAILS = "CLEAR_REGISTRATION_DETAILS";
export const ADD_ERROR = "ADD_ERROR";
export const CLEAR_ERROR = "CLEAR_ERROR";
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
export const CLOSE_APPROVAL_REQUIRED_MODAL = "CLOSE_APPROVAL_REQUIRED_MODAL";
